<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/machine/list" color="blue">上一頁</v-btn>
    </div>

    <v-tabs v-model="tab" class="elevation-2">
      <v-tabs-slider></v-tabs-slider>

      <template v-for="tab in tabList">
        <v-tab>{{ tab.text }}</v-tab>

        <v-tab-item>
          <v-card flat tile>
            <v-card-text>
              <component :is="tab.component" :id="id"></component>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </template>
    </v-tabs>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import MachineInfo from "@/components/Machine/Info";
import MachineWeekday from "@/components/Machine/Weekday";
import MachineDeals from "@/components/Machine/Deals";
import MachinePaymentMethods from "@/components/Machine/PaymentMethods";
import MachineSaleRecords from "@/components/Machine/SaleRecords";
import MachineSettlements from "@/components/Machine/Settlements";

export default {
  components: {
    MachineInfo,
    MachineWeekday,
    MachineDeals,
    MachinePaymentMethods,
    MachineSaleRecords,
    MachineSettlements
  },

  mixins: [],

  props: [],
  data() {
    return {
      id: 0,
      tab: null,
      
      tabList: [
        {
          text: "基本資料",
          component: "MachineInfo"
        },
        // {
        //   text: "優惠時段設定",
        //   component: "MachineWeekday"
        // },
        {
          text: "優惠方案",
          component: "MachineDeals"
        },
        {
          text: "支付方式",
          component: "MachinePaymentMethods"
        },
        {
          text: "銷售紀錄",
          component: "MachineSaleRecords"
        },
        {
          text: "卡機結帳紀錄",
          component: "MachineSettlements"
        }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {},

  mounted() {
    this.id = Number(this.$route.params.id);
  }
};
</script>

<style lang="scss" scoped>
</style>
